import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
	ReportSource,
	reportSourceDetail,
	reportSourceLine
} from '../../../../services/report-source';

/**
 * A slide's source, as one quiet line with the full detail on hover.
 *
 * The line is what reaches the PDF, where nothing hovers, so it carries the
 * whole claim on its own — module, brand, measure, match type, window — and
 * the tooltip only spells each part out. Computed on input rather than in the
 * template so a check of the page does not rebuild two strings per slide.
 */
@Component({
	standalone: true,
	selector: 'app-report-slide-source',
	imports: [MatTooltipModule],
	template: `
		<span
			class="report-source"
			[matTooltip]="detail"
			matTooltipPosition="above"
			matTooltipClass="report-source-tooltip"
		>
			{{ line }}
		</span>
	`,
	styleUrls: ['./report-slide-source.component.scss']
})
export class ReportSlideSourceComponent {
	@Input() set source(value: ReportSource | null) {
		this.line = value ? reportSourceLine(value) : '';
		this.detail = value ? reportSourceDetail(value) : '';
	}

	line = '';
	detail = '';
}
